import { getTrialBanner } from '@mode/shared/util-js';

import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CalendlyPopupButtonComponent } from '../calendly-popup-button/calendly-popup-button.component';

export enum TrialStatus {
  Active = 'active',
  Off = 'off',
  Pending = 'pending',
  Expired = 'expired',
}

@Component({
  standalone: true,
  selector: 'mode-trial-banner',
  imports: [CalendlyPopupButtonComponent, CommonModule],
  templateUrl: './trial-banner.component.html',
  styleUrls: ['./trial-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrialBannerComponent implements OnChanges {
  @Input() billingLink = '';
  @Input() userEmail = '';
  @Input() userDisplayName = '';

  public days = 0;
  public trial: string | null = '';
  public status: TrialStatus | undefined;
  public TrialStatus = TrialStatus;

  constructor(private _window: Window) {}

  ngOnChanges(simpleChanges: SimpleChanges): void {
    this.trial = getTrialBanner(this._window.document) || '';
    this.status = this.getTrialState(this.trial);
    this.userEmail = simpleChanges['userEmail']?.currentValue ?? '';
    this.userDisplayName = simpleChanges['userDisplayName']?.currentValue ?? '';

    if (this.status === TrialStatus.Active) {
      this.days = parseInt(this.trial, 10);
    }
  }

  public getTrialState(trial: string | null): TrialStatus {
    if (!trial) {
      return TrialStatus.Off;
    }
    if (trial === 'no_connections') {
      return TrialStatus.Pending;
    }
    if (trial === 'trial_expired') {
      return TrialStatus.Expired;
    }
    return TrialStatus.Active;
  }
}
